import { __rest as t } from "../../_virtual/_tslib.js";
import { jsx as s } from "react/jsx-runtime";
function r(t) {
  return s("div", Object.assign({}, t));
}
function e(r) {
  var e = r.style,
    i = t(r, ["style"]);
  var n = Object.assign(Object.assign({}, e), {
    right: 2,
    bottom: 2,
    left: 2,
    borderRadius: 3
  });
  return s("div", Object.assign({
    style: n
  }, i));
}
function i(r) {
  var e = r.style,
    i = t(r, ["style"]);
  var n = Object.assign(Object.assign({}, e), {
    right: 2,
    bottom: 2,
    top: 2,
    borderRadius: 3
  });
  return s("div", Object.assign({
    style: n
  }, i));
}
function n(r) {
  var e = r.style,
    i = t(r, ["style"]);
  var n = Object.assign(Object.assign({}, e), {
    cursor: "pointer",
    borderRadius: "inherit",
    backgroundColor: "rgba(0,0,0,.2)"
  });
  return s("div", Object.assign({
    style: n
  }, i));
}
function o(r) {
  var e = r.style,
    i = t(r, ["style"]);
  var n = Object.assign(Object.assign({}, e), {
    cursor: "pointer",
    borderRadius: "inherit",
    backgroundColor: "rgba(0,0,0,.2)"
  });
  return s("div", Object.assign({
    style: n
  }, i));
}
export { n as renderThumbHorizontalDefault, o as renderThumbVerticalDefault, e as renderTrackHorizontalDefault, i as renderTrackVerticalDefault, r as renderViewDefault };